import enMessages from './en'

export default {
  en: enMessages
}
